export default __webpack_public_path__ + "static/media/boarding-start.4c137b27.png";